export const FETCH_RESET_TOKEN = 'FETCH_RESET_TOKEN';
export const FETCH_RESET_TOKEN_SUCCESS = 'FETCH_RESET_TOKEN_SUCCESS';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
